module.exports = __webpack_public_path__ + "img/MO-S.5eb0c1c1.png";